module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"DeliveryDate":{"delivery":"{date} u vás","immediate":"dnes","pickUp":"{date} na pobočce","today":"dnes","tomorrow":"zítra"}},"en":{"DeliveryDate":{"delivery":"{date} at your","immediate":"today","pickUp":"{date} at the branch","today":"today","tomorrow":"tomorow"}}}')
  delete Component.options._Ctor
}
